<template>
    <card-list-item :class="{'active': active}">
        <template v-slot:icon>
            <i class="fa-certificate fa-fw" :class="{'fas': active, 'far': !active}"></i>
        </template>
        <template v-slot:content>
            <div class="tile-title">{{certification.title}}</div>
            <div class="meta" v-if="certification.last_awarded_at"><i class="fas fa-calendar fa-fw mr-2"></i>{{certification.last_awarded_at | moment('MMM Do, YYYY')}}</div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <div class="data mt-1">
                    <data-row mini title="First Awarded" v-if="certification.created_at">{{certification.created_at | moment('MMM Do, YYYY')}}</data-row>
                    <data-row mini title="Last Awarded">{{certification.last_awarded_at | moment('MMM Do, YYYY')}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'WiaaCertificationDetailTile',
        components: {CardListItem, DataRow},
        props: {
            certification: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .tile-details {
        margin-top: 0.5rem;
    }

    .meta {
        font-size: 0.8rem;
        color: #666;
        margin-top: 2px;
    }
</style>